"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _CheckMarkIcon = _interopRequireDefault(require("./CheckMarkIcon"));

var _ExclamationMarkIcon = _interopRequireDefault(require("./ExclamationMarkIcon"));

var _useLocalizer = _interopRequireDefault(require("../hooks/useLocalizer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var NotificationIcon = function NotificationIcon(_ref) {
  var className = _ref.className,
      level = _ref.level;
  var localize = (0, _useLocalizer.default)();
  var prefixes = {
    error: localize('TOAST_ALT_ERROR'),
    info: localize('TOAST_ALT_INFO'),
    success: localize('TOAST_ALT_SUCCESS'),
    warn: localize('TOAST_ALT_WARN')
  };
  var prefix = prefixes[level] || '';
  return _react.default.createElement(_react.default.Fragment, null, level === 'success' ? _react.default.createElement(_CheckMarkIcon.default, {
    "aria-label": prefix,
    className: className
  }) : _react.default.createElement(_ExclamationMarkIcon.default, {
    "aria-label": prefix,
    className: className
  }));
};

NotificationIcon.defaultProps = {
  className: undefined
};
NotificationIcon.propTypes = {
  className: _propTypes.default.string,
  level: _propTypes.default.oneOf(['error', 'info', 'success', 'warn']).isRequired
};
var _default = NotificationIcon;
exports.default = _default;